import React, { useState } from "react";

import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from "reactstrap";
import { pdfjs, Document, Page } from "react-pdf";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import download from "downloadjs";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const DocumentPreviewModal = ({ onClose, file }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDownload = () => download(file);

  const closeBtn = (
    <Button className="close" color="none" onClick={onClose}>
      &times;
    </Button>
  );

  return (
    <Modal isOpen={true} onClosed={onClose} size="lg">
      <ModalHeader close={closeBtn}>Document Preview</ModalHeader>
      <ModalBody className="p-0 text-center">
        <Document
          className="d-flex justify-content-center"
          file={file}
          onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        >
          <Page pageNumber={pageNumber} />
        </Document>
        <div className="d-flex justify-content-between p-3 align-items-center text-body">
          <FontAwesomeIcon
            className="cursor-pointer text-body"
            icon={faChevronLeft}
            onClick={() => setPageNumber(Math.max(pageNumber - 1, 1))}
          />
          <span>
            Page {pageNumber} of {numPages}
          </span>
          <FontAwesomeIcon
            className="cursor-pointer text-body"
            icon={faChevronRight}
            onClick={() => setPageNumber(Math.min(pageNumber + 1, numPages))}
          />
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-start">
        <Button color={"primary"} onClick={onDownload}>
          Download
        </Button>
        <Button color={"secondary"} onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DocumentPreviewModal;
